/* lua.js generated code 0.3.0 */

require("clover/logic/UserEnergy")
UserPropEffectPropRef = table()
function userPropEffectNoEffect(propId, num, levelId, params) { }
// 步数 由游戏逻辑自己处理因此什么都不做
function userPropEffectStep(propId, num, levelId, params) { }
// 银币
function userPropEffectCoin(propId, num, levelId, params) {
    var user = UserManager.getInstance().getUserRef()
    user.setCoin(user.getCoin() + num)
}
// 精力
function userPropEffectEnergy(propId, num, levelId, params) {
    var energyUnit = (MetaManager.getInstance().getPropMeta(propId) || table()).value || 0
    UserEnergy.getInstance().addEnergy(energyUnit * num)
}
// 金豆荚 目前没有该类型道具因此暂时什么都不做
function userPropEffectBean(propId, num, levelId, params) { }
// 果树加速 目前没有该类型道具因此暂时什么都不做
function userPropEffectFruit(propId, num, levelId, params) { }
// 分支关卡 目前没有使用效果
function userPropEffectHideLevel(propId, num, levelId, params) { }
// 精力值无限
function userPropEffectEnergyInfinite(propId, num, levelId, params) {
    var timeInMinute = (MetaManager.getInstance().getPropMeta(propId) || table()).value || 0
    UserEnergy.getInstance().addEnergyInfinity(timeInMinute * 60000 * num)
}
// 复活 目前没有该类型道具因此暂时什么都不做
function userPropEffectRevive(propId, num, levelId, params) { }
// 周赛闯关次数 目前没有该类型道具因此暂时什么都不做
function userPropEffectWeeklyMatch(propId, num, levelId, params) { }
// 索引值是Meta中的reward字段
UserPropEffectTypeRef = table(
    [1, 0, userPropEffectNoEffect],
    [1, 1, userPropEffectStep],
    [1, 2, userPropEffectCoin],
    [1, 3, userPropEffectEnergy],
    [1, 4, userPropEffectBean],
    [1, 5, userPropEffectFruit],
    [1, 6, userPropEffectHideLevel],
    [1, 7, userPropEffectEnergyInfinite],
    [1, 8, userPropEffectRevive],
    [1, 9, userPropEffectWeeklyMatch]
)
function userPropEffect(propId, num, levelId, params) {
    if (type(UserPropEffectPropRef[propId]) === "function") {
        UserPropEffectPropRef[propId](propId, num, levelId, params)
    } else {
        var rewardType = (MetaManager.getInstance().getPropMeta(propId) || table()).reward || 0
        if (type(UserPropEffectTypeRef[rewardType]) === "function") {
            UserPropEffectTypeRef[rewardType](propId, num, levelId, params)
        }
    }
}
module.exports = userPropEffect
